import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Alert, AlertDescription } from "./ui/alert";
import { 
  Users, 
  Download, 
  RotateCcw, 
  AlertCircle,
  CheckCircle
} from "lucide-react";

const ScheduleIStatus = ({ calculationId, contracts }) => {
  const [loading, setLoading] = useState(false);
  const [scheduleIData, setScheduleIData] = useState(null);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <Users className="h-5 w-5 text-blue-600" />
            <span>Schedule I - Contract Status Report</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center py-8">
          <Users className="h-16 w-16 mx-auto mb-4 text-slate-300" />
          <h3 className="text-lg font-medium mb-2 text-slate-600">Schedule I Not Generated</h3>
          <p className="text-sm text-slate-500 mb-4">
            Generate Schedule I to view contract status reporting including remaining funds and completion percentages.
          </p>
          <Button className="bg-blue-600 hover:bg-blue-700">
            <Users className="h-4 w-4 mr-2" />
            Generate Schedule I
          </Button>
        </CardContent>
      </Card>

      <div className="p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center space-x-2 text-sm text-slate-600">
          <AlertCircle className="h-4 w-4" />
          <div>
            <p className="font-medium">Schedule I Information</p>
            <ul className="text-xs mt-1 space-y-1">
              <li>• Contract Status: Remaining funds, percent complete, billing status</li>
              <li>• Financial Metrics: Contract performance and cost tracking</li>
              <li>• DCAA Compliance: Status reporting for contract oversight</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleIStatus;